// extracted by mini-css-extract-plugin
export default {"invoiceSummary":"invoiceSummary_invoiceSummary__daGQe","label":"invoiceSummary_label__tavni"};